/**
 *
 * The deeplink duck.
 *
 * Action Types:
 *
 * DEEP_LINK_REQUESTED
 * DEEP_LINK_RECEIVED
 *
 * Action Creators:
 *
 * deepLinkRequested()
 * deepLinkReceived()
 *
 */

import type {
  DeepLinkAction,
  DeepLinkClickedAction,
  DeepLinkRequestedAction,
  DeepLinkReceivedAction,
  DeepLinkState,
} from '../types';

/** @type {ActionType} */
export const DEEP_LINK_REQUESTED = 'PB/deepLink/DEEP_LINK_REQUESTED';

/** @type {ActionType} */
export const DEEP_LINK_RECEIVED = 'PB/deepLink/DEEP_LINK_RECEIVED';

/** @type {ActionType} */
export const DEEP_LINK_CLICKED = 'PB/deepLink/DEEP_LINK_CLICKED';

/** @ignore **/
export const initialState = {};

/** @ignore **/
export default function deepLink(
  state: DeepLinkState = initialState,
  action: DeepLinkAction,
): DeepLinkState {
  switch (action.type) {
    case DEEP_LINK_REQUESTED: {
      const { id, data } = action.payload;
      let { [id]: deepLink, ...links } = state;

      deepLink = { link: '', data };

      return { ...links, [id]: deepLink };
    }

    case DEEP_LINK_RECEIVED: {
      const { id, link } = action.payload;
      let { [id]: deepLink, ...links } = state;

      deepLink.link = link;

      return { ...links, [id]: deepLink };
    }

    default:
      return state;
  }
}

/*
 * This action creator will return a DEEP_LINK_CLICKED action.
 *
 * This is mostly used for analytics. Once a deep link is clicked, we don't have much else to do (right now).
 *
 * @param {Object} data DeepLink data to go along with the branch link.
 * @param {string} id The identifier for this deep link.
 * @return {DeepLinkReceivedAction}
 */
export function deepLinkClicked(
  id: string,
  data: Object,
  link: string,
): DeepLinkClickedAction {
  return {
    type: DEEP_LINK_CLICKED,
    payload: { id, data, link },
  };
}

/*
 * This action creator will return a DEEP_LINK_REQUESTED action.
 *
 * @param {Object} data DeepLink data to go along with the branch link.
 * @return {DeepLinkRequestedAction}
 */

export function deepLinkRequested(
  id: string,
  data: Object,
): DeepLinkRequestedAction {
  return {
    type: DEEP_LINK_REQUESTED,
    payload: { id, data },
  };
}

/*
 * This action creator will return a DEEP_LINK_REQUESTED action.
 *
 * @param {Object} data DeepLink data to go along with the branch link.
 * @return {DeepLinkReceivedAction}
 */
export function deepLinkReceived(
  id: string,
  link: string,
): DeepLinkReceivedAction {
  return {
    type: DEEP_LINK_RECEIVED,
    payload: { id, link },
  };
}
